import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

import { gerarUrl } from "../../utilities/utils/Pageable";

export default class UserService extends Token {
  searching(queryParams) {
    queryParams = gerarUrl(queryParams);
    return axios({
      method: "get",
      url: this._api_url_intra + "user?" + queryParams,
      withCredentials: true,
    }).then((res) => res.data);
  }

  findById(id) {
    return axios({
      method: "get",
      url: this._api_url_intra + "user/" + id,
      withCredentials: true,
    }).then((res) => res.data);
  }

  updatePassword(id, newPassword) {
    return axios({
      method: "put",
      url: this._api_url_intra + "user/" + id + "/update-password",
      withCredentials: true,
      data: newPassword,
    });
  }



}
